module.exports = __webpack_public_path__ + "img/logo.8cdcfa0c.png";